import { makeBetterEnum } from './betterEnum';

export const ApprovalTargetLockState = makeBetterEnum(
  'Locked',
  'UnlockRequested',
  'Unlocked'
);
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ApprovalTargetLockState =
  (typeof ApprovalTargetLockState)[keyof typeof ApprovalTargetLockState];
